import React, { useState, memo, useEffect, forwardRef, useImperativeHandle } from 'react';
import {
  Checkbox,
  Bubble,
  Table,
} from 'tea-component';
import moment from 'moment';
import {useIntl } from 'umi';
import UpAndDown from '@/pages/dashboard/components/UpAndDown';
import BubbleEllipsis from '@/pages/dashboard/components/BubbleEllipsis';
import {formatNum, formatPercentNum, unitConversion} from '@/pages/dashboard/utils/utils';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { countryList } from '@/pages/dashboard/utils/constant';
import './index.css';
import { useSelectorMap } from '../../utils/customHook';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';
const { scrollable, sortable } = Table.addons;

interface TopTableProps {
  gameCode?: string;
  records: Array<{
    name?: string;
    value?: number | string;
    change?: number | string;
    change_value?: number | string;
    contrast_value?: number | string;
  }>;
  key2?: string;
  header2: string;
  changeSelect: (value: string[]) => void;
  time: {
    nowTime: string;
    preTime: string;
  };
  lastTime: string;
  isKeyCounTry: boolean;
  isRetention?: boolean;
  formatter?: string;
  topTableFormatter?: string;
}

const TopTableCom = (props: TopTableProps, ref: any) => {
  const { records, header2, changeSelect, time, lastTime, isKeyCounTry, isRetention, formatter, topTableFormatter } = props;
  const { nowTime, preTime } = time;
  const { formatMessage } = useIntl();
  const [recordList, setRecordsList] = useState(records || []);
  const { getSelectorText } = useSelectorMap();
  // 表格勾选列表
  const [selectList, setSelectList] = useState<string[]>([recordList?.[0]?.name || '']);
  const [sorts, setSorts] = useState<any[]>();

  useImperativeHandle(ref, () => ({
    getTableHeader: () => getColumns(),
  }));

  const getImg = (iconName: string) => {
    let img = '';
    try {
      img = getCountryFlag(iconName);
    } catch (e) {
      img = getCountryFlag('default');
    }
    return img;
  };

  // 数据格式化函数
  const formatterValue = (value: number) => {
    if (formatter) {
      return dataFormat({ value, formatRule: formatter });
    }
    if (isRetention) {
      return formatPercentNum(value, 2);
    }
    return formatNum(value, false, true);
  };

  // top表格数据格式化函数
  const formatterTopTableValue = (value: number) => {
    if (topTableFormatter) {
      return dataFormat({ value, formatRule: topTableFormatter });
    }
    if (isRetention) {
      return formatPercentNum(value, 2);
    }
    return unitConversion(value, true);
  };

  const defaultOne = isKeyCounTry ? "Total" : "Global";

  useEffect(() => {
    changeSelect(selectList);
  }, [selectList]);

  useEffect(() => {
    setSelectList([defaultOne]);
  }, [isKeyCounTry]);

  useEffect(() => {
    const newRec = records?.filter(item => item?.name !== defaultOne);
    const globalObj = records?.find(item => item?.name === defaultOne);
    // 以后端排序为准
    globalObj && newRec?.unshift(globalObj);
    setRecordsList(newRec || []);
    setSelectList([newRec?.[0]?.name || '']);
  }, [records]);

  const getColumns = () => ([
    {
      key: 'name',
      header: formatMessage({ id: 'realtime_analysis_Country' }),
      align: 'left',
      width: 190,
      render: (cvm: any) => {
        const contentText = (cvm?.name === defaultOne) ? formatMessage({ id: `realtime_analysis_${defaultOne}` }) : getSelectorText('country', cvm?.name);
        const imgName = (cvm?.name?.includes("China") || cvm?.name?.includes("china")) ? 'cn': countryList[cvm?.name];
        return (
          <div className="flex-item">
            {selectList?.length >= 10 && !selectList.includes(cvm?.name) ? (
              <Bubble
                dark
                arrowPointAtCenter
                closeOnScroll
                placement="top-start"
                placementOffset={[10, 10]}
                style={{ left: '7px' }}
                // closeDelay={300}
                content={formatMessage({id: 'realtime_analysis_bubbleText'})}
              >
                <Checkbox
                  value={false}
                  disabled
                  className="top-change-table__country-checkbox disabled"
                  name={cvm?.name}
                >
                  <img
                    className={`country-icon ${cvm?.name === 'Global' || cvm?.name === 'Total' ? 'global' : ''
                    }`}
                    src={getImg(imgName)}
                  />
                  <BubbleEllipsis content={contentText} width='calc(100% - 56px)' maxWidth={110} />
                </Checkbox>
              </Bubble>
            ) : (
              <Checkbox
                className={`top-change-table__country-checkbox color-${selectList.indexOf(cvm?.name) + 1}`}
                name={cvm?.name}
              >
                <img
                  className={`country-icon ${cvm?.name === 'Global' || cvm?.name === 'Total' ? 'global' : ''
                  }`}
                  src={getImg(imgName)}
                />
                <BubbleEllipsis content={contentText} width='calc(100% - 56px)' maxWidth={110} />
              </Checkbox>
            )}
          </div>
        );
      }
    },
    {
      key: 'value',
      header: header2,
      align: 'right',
      // width: '17%',
      width: 101,
      render: (cvm: { value: number; }) => (
        <span className='top-change-table__num'>{formatterTopTableValue(cvm?.value)}</span>
      ),
    },
    {
      key: 'change',
      header: formatMessage({ id: 'realtime_analysis_Change' }),
      align: 'right',
      // width: '29%',
      width: 122,
      render: (cvm: any) => {
        const metricsStatus = (() => {
          if (cvm?.change === 0) return 'zero';
          if (cvm?.change > 0) return 'up';
          if (cvm?.change < 0) return 'down';
          return 'zero';
        })();
        return (
          <Bubble
            closeOnScroll
            dark
            placement="bottom-end"
            content={
              <div className='bubble-item'>
                <div className='bubble-title'>{formatMessage({ id: 'realtime_analysis_.Change' })}</div>
                <div className='bubble-flex'>
                  <div className='bubble-text'>
                    <div className='bubble-t'>{`${nowTime} 00:00 ~ ${moment(lastTime).format('HH:mm') === '00:00' ? '24:00' : moment(lastTime).format('HH:mm')}`}</div>
                    <div className='bubble-b'>{`${preTime} 00:00 ~ ${moment(lastTime).format('HH:mm') === '00:00' ? '24:00' : moment(lastTime).format('HH:mm')}`}</div>
                  </div>
                  <div className='bubble-ct'>VS</div>
                  <div className='bubble-text'>
                    <div className='bubble-t'>{formatterValue(cvm?.value)}</div>
                    <div className='bubble-b'>{formatterValue(cvm?.contrast_value)}</div>
                  </div>
                </div>
              </div>
            }
          >
            <section>
              <UpAndDown
                data={formatPercentNum(cvm?.change, 1)}
                status={metricsStatus}
                style={{display: 'block'}}
              />
            </section>
          </Bubble>
        );
      },
    },
    {
      key: 'change_value',
      header: formatMessage({ id: isRetention? 'realtime_analysis_New' : 'realtime_analysis_Change_Value' }),
      align: 'right',
      width: 110,
      render: (cvm: any) => {
        const status = (() => {
          if (cvm?.change_value === 0) return 'zero';
          if (cvm?.change_value > 0) return 'up';
          if (cvm?.change_value < 0) return 'down';
          return 'zero';
        })();

        return (<UpAndDown
          data={unitConversion(cvm?.change_value, false, false, true)}
          status={status}
          style={{display: 'block'}}
        />);
      },
    },
  ]);

  return (
    <Checkbox.Group
      value={selectList}
      onChange={v => {
        // 只勾选了Global时默认为默认勾选，此时勾选其他国家将过滤掉Global勾选
        if (JSON.stringify(selectList) === '["Global"]' || JSON.stringify(selectList) === '["Total"]') {
          setSelectList(v?.filter((t: string) => t !== defaultOne));
          return;
        }
        const nameList = recordList.map(v => v.name);
        v.sort((a, b) => nameList.indexOf(a) - nameList.indexOf(b));
        
        setSelectList(v);
      }}
    >
      <Table
        className='analysis-left tableFixed'
        records={recordList as []}
        // bordered
        columns={getColumns()}
        addons={[
          scrollable({
            minHeight: 345,
            maxHeight: 345,
          }),
          sortable({
            columns: [
              {
                key: 'value',
                prefer: 'desc'
              },
              {
                key: 'change',
                prefer: 'desc'
              },
              {
                key: 'change_value',
                prefer: 'desc'
              }
            ],
            value: sorts,
            onChange: (value) => {
              let newValue: any = value;
              if (value?.length === 2) {
                newValue = [value.find(item => item.by !== sorts?.[0]?.by)];
              }

              // global和Total不参与排序
              let sortList = JSON.parse(JSON.stringify(records)).filter((item: { name: string; }) => item.name !== defaultOne);
              // let sortName = newValue[0]?.by === key2 ? 'value' : 'change'
              const sortName = newValue[0]?.by;
              const globalObj = records.find(item => item.name === defaultOne);

              if (newValue[0]?.order === 'desc') {
                sortList.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => Math.abs(b[sortName]) - Math.abs(a[sortName]));
              } else if (newValue[0]?.order === 'asc') {
                sortList.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => Math.abs(a[sortName]) - Math.abs(b[sortName]));
              }

              // change排序把空放最后面
              if (sortName === 'change') {
                const changeNull = sortList.filter((item: { change: string; }) => !item.change);
                sortList = sortList.filter((item: { name: string; change: string; }) => item.name !== defaultOne && item.change);
                sortList.push(...changeNull);
              }

              globalObj && sortList.unshift(globalObj);
              const newNameList = sortList.map((v: { name: string; }) => v.name);
              selectList.sort((a, b) => newNameList.indexOf(a) - newNameList.indexOf(b));

              setSelectList(selectList);
              setRecordsList(sortList);
              setSorts(newValue);
            },
          })
        ]}
      />
    </Checkbox.Group>
  );
};

const TopTable = forwardRef(TopTableCom);
export default memo(TopTable);

